import React, { FunctionComponent, ReactNode } from 'react';
import { LoaderWrapper, ErrorTitle, ErrorWrapper, Message } from './styles';
import { Attention } from '@lt/components/icons-react';

type Props = {
  title?: ReactNode;
  message?: ReactNode;
  isError?: boolean;
  errorTitle?: ReactNode;
  errorMessage?: ReactNode;
  children?: ReactNode;
};

export const WidgetLoaderView: FunctionComponent<Props> = ({
  title,
  message,
  errorTitle,
  errorMessage,
  isError,
  children,
}) => {
  return (
    <LoaderWrapper>
      {isError && (
        <ErrorWrapper>
          <Attention width={60} />
          <ErrorTitle>{errorTitle || 'Возникла ошибка'}</ErrorTitle>
          {errorMessage && <Message>{errorMessage}</Message>}
        </ErrorWrapper>
      )}
      {!isError && title && (
        <ErrorWrapper>
          <ErrorTitle>{title}</ErrorTitle>
          {message && <Message>{message}</Message>}
        </ErrorWrapper>
      )}
      {children}
    </LoaderWrapper>
  );
};
